import styles from "./RulesOfReferral.module.scss";
import ArrowBack from "../../../../styles/icon/arrow_back_fill.svg";
import { useHistory } from "react-router";
export default function RulesOfReferral() {
  const history = useHistory();
  return (
    <div className={styles.container}>
      <div className={styles.backIcon_container}>
        <img
          src={ArrowBack}
          alt="BACK"
          width={17}
          height={17}
          onClick={() => history.goBack()}
          className="convertPicToWhite"
        />
      </div>
      <div className={`font_color_white ${styles.title_of_page}`}>
        قوانین طرح پاداش معرفی
      </div>
      <ul className={styles.rules_text_container}>
        <li className={styles.rules_text_item}>
          1.تنها در هنگام ثبت نام امکان ثبت کد دعوت شما توسط دوستانتان وجود دارد
          و پس از انجام ثبت نام امکان ویرایش و کد دعوت شما به عنوان معرف هیچ کس
          وجود ندارد .
        </li>
        <li className={styles.rules_text_item}>
          2.هر کاربر امکان ایجاد ۲۰ کد دعوت اختصاصی را دارد .
        </li>
        <li className={styles.rules_text_item}>
          3.شما میتوانید قسمتی از پاداش معرفی دوستانتان را به حساب خودشان واریز
          کنید . برای انجام این کار کافیست لینک دعوت خود را ویرایش نمایید.
        </li>
        <li className={styles.rules_text_item}>
          4.با توجه به حجم معاملات روزانه خود امکان دریافت درصد بیشتری از دعوت
          هر دوست امکان پذیر میباشد .
        </li>
        <li className={styles.rules_text_item}>
          5.ارزفی اجازه نمی دهد که کاربران با استفاده از چندین حساب خود اقدام به
          دعوت از سایر دوستان نماینددر صورت مشاهده ، همه پاداش ها لغو می شود و
          همه حساب ها مسدود خواهند شد .
        </li>
      </ul>
    </div>
  );
}
